import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
import {load} from '@shopify/theme-sections';

import '../sections/header';
import '../sections/sort';

import {QuickShop} from '../components/quick-shop';
import {MiniCart} from '../components/mini-cart';


// Common a11y fixes
focusHash();
bindInPageLinks();

// Mouse vs keyboard focus detection for .js-focus-hidden
document.body.addEventListener('mousedown', () => {
  document.body.classList.add('js-focus-hidden-active');
});
document.body.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    document.body.classList.remove('js-focus-hidden-active');
  }
});
document.addEventListener('focusin', (e) => {
  if (document.body.classList.contains('js-focus-hidden-active')) {
    e.target.classList.add('js-focus-hidden');
  }
});
document.addEventListener('focusout', (e) => {
  e.target.classList.remove('js-focus-hidden');
});
load('header');

if (typeof window.theme === 'undefined') {
  window.theme = {};
}

window.theme.quickShop = new QuickShop();
window.theme.minicart = new MiniCart();
